import { render, staticRenderFns } from "./MessageEventX.vue?vue&type=template&id=079f52fc"
import script from "./MessageEventX.vue?vue&type=script&lang=js"
export * from "./MessageEventX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports